import React from 'react';
import '../styles/ReviewStats.css'; // Pour vos styles
import StarRating from '../StarRating'; // Assurez-vous du bon chemin

const ReviewStats = ({ reviews }) => {
    if (!reviews || reviews.length === 0) {
        return (
            <div className="review-stats">
                <h4>Statistiques</h4>
                <p>Aucun avis pour le moment.</p>
            </div>
        );
    }

    // Calcul de la moyenne globale
    const overallAverage =
        reviews.reduce((sum, review) => sum + review.rating, 0) / reviews.length;

    // Calcul de la moyenne par type de contributeur
    const typeRatings = {};
    reviews.forEach((review) => {
        if (review.reviewerType) {
            if (!typeRatings[review.reviewerType]) {
                typeRatings[review.reviewerType] = { total: review.rating, count: 1 };
            } else {
                typeRatings[review.reviewerType].total += review.rating;
                typeRatings[review.reviewerType].count += 1;
            }
        }
    });

    const typeAverages = Object.entries(typeRatings).map(
        ([type, { total, count }]) => ({
            type,
            average: total / count,
        })
    );

    return (
        <div className="review-stats">
            <h2>Statistiques</h2>
            <div className="overall-average">
                <h3><span>Moyenne générale&nbsp;:</span></h3>
                {/* Ici, le composant StarRating doit pouvoir fonctionner en lecture seule */}
                <StarRating initialRating={overallAverage} readOnly={true} />
                <span>{overallAverage.toFixed(1)} / 5</span>
            </div>
            <div className="type-averages">
                {typeAverages.map(({ type, average }) => (
                    <div key={type} className="type-average">
            <span>
              {type === 'Presse'
                  ? 'Presse'
                  : type === 'Cinema'
                      ? 'Milieu du cinéma'
                      : 'Cinephile'}
                &nbsp;:
            </span>
                        <StarRating initialRating={average} readOnly={true} />
                        <span>{average.toFixed(1)} / 5</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReviewStats;
